import { 
  Eye, 
  Edit, 
  Trash2, 
  Navigation, 
  Truck, 
  Route, 
  Calendar, 
  Package,
  Share2 
} from 'lucide-react';
import { getStatusConfig, formatCurrency } from '../../../../utils/utils';
import PaymentTypeIcon from '@/pages/admin/components/icons/PaymentTypeIcon';

const TransportMobileCards = ({ transports, onView, onEdit, onDelete, onShareLocation }) => {
  const MobileTransportCard = ({ transport }) => {
    const statusConfig = getStatusConfig(transport.status);
    
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 space-y-3">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-r from-orange-500 to-red-500 rounded-lg flex items-center justify-center">
              <Truck className="w-5 h-5 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">{transport.id}</h3>
              <p className="text-sm text-gray-500">{transport.client}</p>
            </div>
          </div>
          <span className={`px-2.5 py-1 rounded-full text-xs font-medium border ${statusConfig.color} flex items-center`}>
            {statusConfig.icon}
            <span className="ml-1">{statusConfig.text}</span>
          </span>
        </div>

        {/* Content */}
        <div className="space-y-2">
          {/* Route */}
          <div className="flex items-center text-sm text-gray-600">
            <Route className="w-4 h-4 mr-2 text-gray-400" />
            {transport.route}
          </div>
          
          {/* Description */}
          {transport.description && (
            <div className="flex items-center text-sm text-gray-500">
              <Package className="w-4 h-4 mr-2 text-gray-400" />
              <span className="truncate">{transport.description}</span>
            </div>
          )}

          {/* Current Position */}
          {transport.vehicul_adresa && (
            <div className="flex items-start text-sm text-gray-600">
              <Navigation className="w-4 h-4 mr-2 text-gray-400 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-xs text-gray-600">{transport.vehicul_adresa}</p>
                {transport.vehicul_ultima_pozitie && (
                  <p className="text-xs text-gray-400">
                    {new Date(transport.vehicul_ultima_pozitie).toLocaleString('ro-RO')}
                  </p>
                )}
              </div>
            </div>
          )}
          
          {/* Date and Value */}
          <div className="flex items-center justify-between text-sm">
            <div className="flex items-center text-gray-600">
              <Calendar className="w-4 h-4 mr-2 text-gray-400" />
              {transport.date}
            </div>
            <div className="flex items-center space-x-1">
              <PaymentTypeIcon tip_plata={transport.tip_plata} />
              <span className="font-semibold text-gray-900">
                {formatCurrency(transport.value)}
              </span>
            </div>
          </div>

          {/* Weight */}
          {transport.weight && (
            <div className="flex items-center text-sm text-gray-500">
              <span className="text-xs">Greutate: {transport.weight}</span>
            </div>
          )}

          {/* Driver & Vehicle */}
          <div className="text-sm text-gray-600">
            <p className="font-medium">{transport.driver}</p>
            <p className="text-xs text-gray-500">{transport.vehicle}</p>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center justify-between pt-2 border-t border-gray-100">
          <div className="flex items-center space-x-2">
            {/* View Details */}
            <button 
              onClick={() => onView(transport)}
              className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
              title="Vezi detalii"
            >
              <Eye className="w-4 h-4" />
            </button>

            {/* Edit */}
            <button 
              onClick={() => onEdit(transport)}
              className="p-2 text-orange-600 hover:bg-orange-50 rounded-lg transition-colors"
              title="Editează"
            >
              <Edit className="w-4 h-4" />
            </button>
            
            {/* Share Location */}
            <button 
              onClick={() => onShareLocation(transport)}
              className="p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
              title="Partajează locația"
            >
              <Share2 className="w-4 h-4" />
            </button>

            {/* Send Live Location (doar pentru transporturi în tranzit) */}
            {transport.status === 'pe_drum' && (
              <button 
                onClick={() => onShareLocation(transport)}
                className="p-2 text-purple-600 hover:bg-purple-50 rounded-lg transition-colors"
                title="Trimite locația live"
              >
                <Navigation className="w-4 h-4" />
              </button>
            )}
          </div>

          {/* Delete */}
          <button 
            onClick={() => onDelete(transport)}
            className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            title="Șterge"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="lg:hidden space-y-4">
      {transports.map((transport) => (
        <MobileTransportCard key={transport.id} transport={transport} />
      ))}
      
      {/* Empty State for Mobile */}
      {transports.length === 0 && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 text-center">
          <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Truck className="w-6 h-6 text-gray-400" />
          </div>
          <p className="text-gray-500">Nu există transporturi de afișat</p>
        </div>
      )}
    </div>
  );
};

export default TransportMobileCards;